export default "__VITE_ASSET__g5l1jRro__"